import { useEffect, useState } from 'react';
import { adminApi } from '../services/api';

export function AdminAuditPage() {
  const [logs, setLogs] = useState<Array<Record<string, unknown>>>([]);
  const [alerts, setAlerts] = useState<Array<Record<string, unknown>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([adminApi.getAuditLogs(), adminApi.getSecurityAlerts()])
      .then(([logRes, alertRes]) => {
        setLogs(logRes.logs);
        setAlerts(alertRes.alerts);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="p-8">
        <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-8 max-w-5xl space-y-8">
      <h1 className="text-2xl font-bold">Audit & Security</h1>

      <section>
        <h2 className="text-lg font-semibold mb-4">Security alerts</h2>
        <div className="card divide-y divide-border">
          {alerts.length === 0 ? (
            <p className="p-4 text-sm text-foreground-secondary">No alerts</p>
          ) : (
            alerts.map((a) => (
              <div key={String(a.id)} className="p-4 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium text-foreground">{String(a.title)}</span>
                  <span className="text-foreground-muted">{String(a.severity)}</span>
                </div>
                <p className="text-foreground-secondary mt-1">{String(a.description)}</p>
              </div>
            ))
          )}
        </div>
      </section>

      <section>
        <h2 className="text-lg font-semibold mb-4">Audit log</h2>
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-background-tertiary text-foreground-secondary">
              <tr>
                <th className="text-left p-3">Action</th>
                <th className="text-left p-3">User</th>
                <th className="text-left p-3">IP</th>
                <th className="text-left p-3">Time</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={String(log.id)} className="border-t border-border">
                  <td className="p-3">{String(log.action)}</td>
                  <td className="p-3 text-foreground-muted">{String(log.userId || '—')}</td>
                  <td className="p-3 text-foreground-muted">{String(log.ipAddress || '—')}</td>
                  <td className="p-3 text-foreground-muted">
                    {log.createdAt ? new Date(String(log.createdAt)).toLocaleString() : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
